import axios from 'axios';

import { apiUrl } from '../apiUrl';
import { compareValues } from '../utility';

export let franchises = [];
export let socialProofAmount = 0;
export let infoBarTexts = [];

const fetchAll = async () => {
  try {
    const res = await axios.get(`${apiUrl}/franchises`);

    return {
      franchises: sortByNameButPoznanFirst(res.data.franchises),
      socialProof: res.data.social_proof_amount,
      infoBarTexts: res.data.infoBarTexts,
    };
  } catch (error) {
    console.warn(error);
  }
};

const sortByName = (franchises) => {
  return franchises.sort(compareValues('name'));
};

const sortByNameButPoznanFirst = (franchises) => {
  const poznanFranchise = franchises.filter((franchise) => {
    return franchise.slug === 'poznan';
  });
  const allOtherFranchises = franchises.filter((franchise) => {
    return franchise.slug !== 'poznan';
  });

  return [...poznanFranchise, ...sortByName(allOtherFranchises)];
};

// const sortByOrder = franchises => {
//   return franchises.sort(compareValues('order'));
// };

// export const getCoordinates = id => {
//   const franchise = getFranchiseById(id);
//   const coordinates = { lat: 52.409538, lng: 16.931992 };

//   if (!franchise) {
//     return coordinates;
//   }

//   if (franchise.latitude) {
//     coordinates.lat = +franchise.latitude;
//   }

//   if (franchise.longitude) {
//     coordinates.lng = +franchise.longitude;
//   }

//   return coordinates;
// };

// export const getLevels = id => {
//   const franchise = getFranchiseById(id);

//   if (!franchise) {
//     return [];
//   }

//   return sortByOrder(franchise.levels);
// };

// const getFranchiseById = id => {
//   return franchises.find(franchise => {
//     return franchise.id === id;
//   });
// };

export const setAll = async () => {
  try {
    const data = await fetchAll();
    franchises = data.franchises;
    socialProofAmount = data.socialProof;
    infoBarTexts = data.infoBarTexts;
  } catch (error) {
    console.log(error);
  }
};
